<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import firebase from 'firebase/app';

/**
 * Invoice-detail component
 */
export default {
  page: {
    title: "Payout Details",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Payout Details",
      items: [
        {
          text: "Deshboard",
          href: "/",
        },
        {
          text: "Payout Details",
          active: true,
        },
      ],
      payout: {},
      payoutStatus: [
          { value: "Processing", text: "Processing" },
          { value: "Deposited", text: "Deposited" },
      ],
      selectedStatus: "Processing",
      options: {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
      },
    };
  },
  methods: {
    async updatePayout(){
      await firebase.firestore().collection("payouts").doc(this.payout.id)
      .update({
        status: this.selectedStatus,
        depositDate: this.selectedStatus == "Deposited" ? firebase.firestore.FieldValue.serverTimestamp(): null
      })
    },
      async getData(payoutId){
          await firebase.firestore().collection("payouts").doc(payoutId).get()
          .then((singleDoc)=>{
            this.selectedStatus = singleDoc.data().status ?? "Processing";
              this.payout = {
                  id: singleDoc.id,
              date: singleDoc.data().date.toDate().toLocaleDateString("en-US", this.options),
              bankDetails: singleDoc.data().bankDetails,
              paypalLink: singleDoc.data().paypalLink ?? null,
              preferred: singleDoc.data().preferred ?? "bank",
              status: singleDoc.data().status,
              depositor: singleDoc.data().depositor,
              userId: singleDoc.data().userId,
              storeId: singleDoc.data().storeId,
              totalDeposited: singleDoc.data().totalDeposited,
            //   feePercent: singleDoc.data().feePercent,
              feeAmount: singleDoc.data().feeAmount,
              transactions: singleDoc.data().transactions,
              storeName: singleDoc.data().storeName,
              storeNumber: singleDoc.data().storeNumber,
              bankFee: singleDoc.data().bankFee,
              total: singleDoc.data().total
              }
              //calculate totals :
                        // this.payout.transactions.forEach((element)=>{
                        //   this.total = this.total + element.total
                        //   this.totalFees = this.totalFees + element.feeAmount
                        // })
                        // this.bankFees = (6/100 * this.total);
          })
      }
  },
  mounted(){
      const urlParams = new URLSearchParams(window.location.search)
    if (urlParams) {
      const myParam = urlParams.get("id")
      this.getData(myParam)
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div v-if="payout" class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="invoice-title">
              <h4 class="float-end font-size-16">Payout ID: {{payout.id}}</h4>
              <div class="mb-4">
                <img
                  src="@/assets/images/logo-dark.png"
                  alt="logo"
                  height="20"
                />
              </div>
            </div>
            <hr />
            <div class="row">
              <div v-if="payout.preferred == 'bank'" class="col-6">
                <address v-if="payout.bankDetails">
                  <strong>Pay To:</strong>
                  <br />{{payout.bankDetails.nameOnAcct}} <br />{{payout.bankDetails.bankName}} <br />{{payout.bankDetails.bankBranch}}
                  <br />{{payout.bankDetails.bankNumber}}
                </address>
              </div>
              <div v-else class="col-6">
                <address>
                  <strong>Pay Via Paypal:</strong>
                  <br />{{payout.paypalLink}}
                </address>
              </div>
              <div class="col-6 text-sm-end">
                <address>
                  <strong>Business:</strong>
                  <br />{{payout.storeName}} <br />{{payout.storeNumber}} 
                  <!-- <br />Apt. 4B
                  <br />Springfield, ST 54321 -->
                </address>
              </div>
            </div>
            <div class="row">
              <div class="col-6 mt-3">
                <address v-if="payout.total">
                  <strong>Break Down:</strong>
                  <br />Total: ${{payout.total.toFixed(2)}} <br />Total Fees: ${{payout.feeAmount.toFixed(2)}} <br />
                  Bank + Anselm Fees ( 5%): ${{payout.bankFee.toFixed(2)}}
                </address>
              </div>
              <div class="col-6 mt-3 text-sm-end">
                <address v-if="payout">
                  <strong>Payout Date:</strong>
                  <br />{{payout.date}}
                  <div class="d-print-none">
            <b-form-select @change="updatePayout()" v-model="selectedStatus" :options="payoutStatus" class="mb-3" />
        </div>
                  <br />
                </address>
              </div>
            </div>
            <div class="p-2 mt-3">
              <h3 class="font-size-16">Payout transactions</h3>
            </div>
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Invoice Number</th>
                    <th>Trans Id</th>
                    <th>Fee Amount</th>
                    <th>Fee (%)</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody v-if="payout.transactions">
                  <tr v-for="trans in payout.transactions" :key="trans.transactionId">
                    <!-- <th scope="row">1</th> -->
                    <td>{{trans.date.toDate().toLocaleDateString("en-US", options)}}</td>
                    <td>{{trans.invoiceNumber}}</td>
                    <td>{{trans.transactionId}}</td>
                    <td>${{trans.feeAmount.toFixed(2)}}</td>
                    <td>{{trans.feePercent}}%</td>
                    <td>${{trans.total.toFixed(2)}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="d-print-none">
              <div class="float-end">
                <a
                  href="javascript:window.print()"
                  class="btn btn-success waves-effect waves-light me-1"
                  ><i class="fa fa-print"></i
                ></a>
                <!-- <a
                  href="#"
                  class="btn btn-primary w-md waves-effect waves-light"
                  >Send</a
                > -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>